export enum LoadIndicatorColorEnum {
    Blue = 'blue',
    White = 'white',
    DarkerGreen = 'darker-green',
    ErrorRed = 'error-red',
}
